//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowBigUp(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 7.13994L19 12.1799V9.55994L12 3.68994L5 9.55994V12.1799L11 7.13994V19.9999H13V7.13994Z" fill="currentColor" /></svg>;
}
export default IconArrowBigUp;